import { CAMPAIGN_DIALOG_MESSAGES, CampaignDialogMessages } from "./campaigns-dialog.messages";
import { POPOVER_MESSAGES, PopoverMessages } from "../popover.messages";
import { TABLE_COLUMNS_MESSAGES, TableColumnsMessages } from "../tables/columns.messages";

export type CampaignsTableMessages = CampaignDialogMessages &
  PopoverMessages &
  TableColumnsMessages & {
    //Titles messages
    campaignTableTitle: string;

    // Column Labels
    listNameColumn: string;
    parentListIdColumn: string;
    factorColumn: string;
    optionsColumn: string;
  };

export const CAMPAIGNS_TABLE_MESSAGES: CampaignsTableMessages = {
  //Titles messages
  campaignTableTitle: "Listagem de Campanhas",

  // Column Labels
  listNameColumn: "Lista",
  parentListIdColumn: "Lista pai",
  factorColumn: "Fator",

  ...TABLE_COLUMNS_MESSAGES,
  ...CAMPAIGN_DIALOG_MESSAGES,
  ...POPOVER_MESSAGES,
};
